
module.exports = { 
      attributes: {"title":"legals","name":"La Fabrik","address":"33 ter rue jean jaurès 98800 Nouméa","publication":"La Fabrik","url":"https://rdv.nc","mail":"support@la-fabrik.nc","phone":"263904","gacode":"GA-"},
    
      html: "",
     }